import { render, staticRenderFns } from "./Renzheng.vue?vue&type=template&id=c99cbc78&scoped=true"
import script from "./Renzheng.vue?vue&type=script&lang=js"
export * from "./Renzheng.vue?vue&type=script&lang=js"
import style0 from "./Renzheng.vue?vue&type=style&index=0&id=c99cbc78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99cbc78",
  null
  
)

export default component.exports